/**
 * API de IA — Análisis y entrevista BA
 */
import client from './client';

export const aiApi = {
  analyze: (description, customPrompt = '') =>
    client.post('/ai/analyze', { description, custom_prompt: customPrompt }),

  sendInterviewMessage: (messages, customPrompt = '') =>
    client.post('/ai/interview/message', { messages, custom_prompt: customPrompt }),

  extractSummary: (messages) =>
    client.post('/ai/interview/extract-summary', { messages }),

  calculateTimeline: (phases, startDate, userLevel = 'MID') =>
    client.post('/ai/timeline', { phases, start_date: startDate, user_level: userLevel }),
};
